import _ from 'lodash'

export function generateChartData (job) {
  const wbcChartData = {
    labels: job.xPositions,
    datasets: [
      {
        fill: false,
        lineTension: 0.1,
        backgroundColor: ['rgba(75,192,192,0.4)'],
        borderColor: ['rgba(75,192,192,1)'],
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        label: 'Counts per position',
        data: job.cellsPerImage
      }
    ]
  }

  const neutrophilChartData = {
    labels: job.xPositions,
    datasets: [
      {
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(255,99,132,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(255,99,132,1)',
        pointHoverBorderColor: 'rgba(255,99,132,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        label: 'Neutrophil % per position',
        data: _.map(job.neutrophilPercentPerImage, (n) => Number(n).toFixed(2))
      }
    ]
  }

  const neutrophilChartDataCenter = {
    labels: job.xPositions,
    datasets: [
      {
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(255,99,132,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(255,99,132,1)',
        pointHoverBorderColor: 'rgba(255,99,132,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        label: 'Neutrophil % per position Center',
        data: _.map(job.neutrophilPercentCenterPerImage, (n) => Number(n).toFixed(2))
      }
    ]
  }

  const neutrophilChartDataOuter = {
    labels: job.xPositions,
    datasets: [
      {
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(255,99,132,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(255,99,132,1)',
        pointHoverBorderColor: 'rgba(255,99,132,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        label: 'Neutrophil % per position Outer',
        data: _.map(job.neutrophilPercentOuterPerImage, (n) => Number(n).toFixed(2))
      }
    ]
  }

  return {
    wbcChartData,
    neutrophilChartData,
    neutrophilChartDataCenter,
    neutrophilChartDataOuter
  }
}



// WEBPACK FOOTER //
// ./src/lib/chartHelpers.js